import api from "../..";
import type { DeleteStoryParams } from "./types";

export const deleteStory = async ({ uuid }: DeleteStoryParams): Promise<boolean> => {

  return await api.delete(`/admin/story/${uuid}/`)
  .then(() => true)
  .catch(() => false);
};
